import { render, staticRenderFns } from "./NewsTrends.vue?vue&type=template&id=cc869516&"
import script from "./NewsTrends.vue?vue&type=script&lang=js&"
export * from "./NewsTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports